import { FC, ReactNode } from 'react';
import { Card, CardContent, ScrollArea } from '@ibsys/kit';
import { cn } from '@/shared/lib';

type Props = {
  label: ReactNode;
  value: ReactNode;
  /** true — уменьшает размер значения (для длинных строк, например названия критерия) */
  compact?: boolean;
  /** Размер значения, выбранный пользователем; задан — заменяет размер по умолчанию */
  valueSizeClass?: string;
  /**
   * Карточка вписывается в отведённую ей высоту: рамка видна целиком, а не поместившиеся подпись и
   * значение прокручиваются внутри неё. Не задано — карточка высотой по содержимому.
   */
  fitsHeight?: boolean;
};

/**
 * Карточка KPI: подпись сверху, крупное значение снизу.
 * Используется в верхнем ряду метрик дашборда и показателем пользовательского дашборда.
 */
export const KpiCard: FC<Props> = ({ label, value, compact, valueSizeClass, fitsHeight }) => {
  const content = (
    <CardContent className="p-4">
      <div className="text-xs text-muted-foreground mb-1">{label}</div>
      <div className={cn('font-bold', valueSizeClass ?? (compact ? 'text-lg' : 'text-2xl'))}>{value}</div>
    </CardContent>
  );

  if (!fitsHeight) return <Card>{content}</Card>;

  return (
    <Card className="min-h-0 overflow-hidden">
      <ScrollArea className="min-h-0 flex-1">{content}</ScrollArea>
    </Card>
  );
};
